import addWindowScrollPositionToDocument from './modules/viewport';
import initClosestContainerSearch from './modules/closest-container';
import initContainerRequest from './modules/container-request';
import initContrastMode from './modules/contrasts';
import initGarbageAbcSearch from './modules/garbage-abc';
import initGarbageCalendarSearch from './modules/garbage-calendar';
import initMap from './modules/maps';
import initMunicipalitySelector from './modules/municipality';
import initTabs from './modules/tabs';
import initToggle from './modules/toggle';
import initWastePassRequest from './modules/waste-pass-request';
import CookieConsent from './modules/cookie-consent';
import companySlider from './modules/company-slider';
import Chocolat from 'chocolat';

import * as Cookie from './modules/cookie';
import * as Modal from './modules/modal';

addWindowScrollPositionToDocument();

initClosestContainerSearch();
initContainerRequest();
initContrastMode();
initGarbageAbcSearch();
initGarbageCalendarSearch();
initMap();
initMunicipalitySelector();
initTabs();
initToggle();
initWastePassRequest();
companySlider();
Chocolat(document.querySelectorAll('.chocolat-image'));

window.onload = () => {
    Modal.init('municipality', true);
    Cookie.set('contrast', Cookie.get('contrast') ?? 'low', 43800);

    const cookieConsent = new CookieConsent(document);
    if (document.querySelector('[data-cmeleon-cookie-notice]') !== null) {
        setTimeout(() => cookieConsent.showNotice(), 2000);
    }
};
